export default {
      id: "at-solid-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#at-solid",
      toString: function () {
        return this.url;
      }
    }